import {Selector} from '@ngxs/store';
import {AdvertiserMediaModel} from './advertiser-media.model';
import {IMediaItem} from '@interfaces/media';
import {AdvertiserMediaState} from './advertiser-media.state';
import {ViewType} from '@shared/enums/view-type.enum';
import {MediaTypeEnum} from '@shared/enums/media-type.enum';

export class AdvertiserMediaSelectors {
  @Selector([AdvertiserMediaState])
  static getAdvertiserMedia(state: AdvertiserMediaModel): IMediaItem[] | null {
    return state.media;
  }

  @Selector([AdvertiserMediaState])
  static getAdvertiserMediaSearch(state: AdvertiserMediaModel): string {
    return state.search;
  }

  @Selector([AdvertiserMediaState])
  static getAdvertiserMediaCurrentPage(state: AdvertiserMediaModel): number {
    return state.currentPage;
  }

  @Selector([AdvertiserMediaState])
  static getAdvertiserMediaPerPage(state: AdvertiserMediaModel): number {
    return state.itemsPerPage;
  }

  @Selector([AdvertiserMediaState])
  static getAdvertiserMediaViewType(state: AdvertiserMediaModel): ViewType {
    return state.viewType;
  }

  @Selector([AdvertiserMediaState])
  static getAdvertiserTotalMedia(state: AdvertiserMediaModel): number {
    return state.totalMediaNum;
  }

  @Selector([AdvertiserMediaState])
  static getAdvertiserMediaLoader(state: AdvertiserMediaModel): boolean {
    return state.loader;
  }

  @Selector([AdvertiserMediaState])
  static getAdvertiserMediaType(state: AdvertiserMediaModel): MediaTypeEnum | null {
    return state.mediaType;
  }
}
